import { formulaNew } from "../../formula/formulaNew";
import { isFormula } from "../../formula/formulaParsing";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_16: DocMigration = {
  maxSchemaVersion: "0.0.16",
  apply(json: any) {
    const fixStaticDrawings = (staticDrawings: any) => {
      if (!staticDrawings) {
        return;
      }

      for (const drawing of staticDrawings) {
        if (isFormula(drawing.disabled) && drawing.disabled.formula === "not (false)") {
          drawing.disabled = formulaNew(`not (true)`);
        }
      }
    };

    const staticPlanSheets = json.planOutputConfig?.staticPlanSheets;
    if (staticPlanSheets) {
      for (const sheet of staticPlanSheets) {
        if (isFormula(sheet.disabled) && sheet.disabled.formula === "not (false)") {
          sheet.disabled = formulaNew(`not (true)`);
        }
        if (sheet.type === "ADD_REPLACE") {
          fixStaticDrawings(sheet.staticDrawings);
        }
      }
    }

    for (const blockId in json.blocks) {
      const block = json.blocks[blockId];
      if (!block.layouts) {
        continue;
      }

      for (const blockLayoutId in block.layouts) {
        const blockLayout = block.layouts[blockLayoutId];
        for (const locationId in blockLayout.rooms) {
          const room = blockLayout.rooms[locationId];

          fixStaticDrawings(room.layout?.drawings);
        }
      }
    }

    return json;
  },
};

export default migration_0_0_16;
